import groups from '../data/groups/Groups';

export default {
  /**
   * Retourne une string html formatant les permissions passés en parametres en pills de couleurs
   * Possible d'ajouter une class supplémentaire en paramètre
   * @param permissions
   * @param className
   * @returns {string}
   */
  userGroup(permissions, className) {
    let group = '';
    permissions.forEach((permission) => {
      const find = groups.find(el => el.reference === permission.groupReference);
      const txtColor = find.txtColor ? find.txtColor : '#6f6f6f';
      group += `<span style="background-color: ${find.color};color: ${txtColor};" class="badge badge-pill mr-1 text-uppercase border ${className}">${find.name}</span>`;
    });
    return group;
  },
};
